import React, { Component } from 'react';
import "./MobileHeader.scss";

export default class MobileHeader extends Component {
  render() {
    return (
      <section className="section section-mobileheader">
        <div className="padding">
          <div className="container">
            <div className="headline">
              אטרקציות לפסח <span>בחינם 2019</span>
            </div>
            <div className="spons">
              <div className="text">בשיתוף</div>
              <div className="logo"></div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/MobileHeader/MobileHeader.jsx